// One theme, as a card: a still of its scene with two of its tiles on it, its
// name, and who made it. Pointing at it tries it on the board. A card with a
// menu opens it on a right click too.

import { useEffect, useMemo, useRef } from "react";
import { cx } from "../lib/util";
import { themeThumb } from "./sceneOf";
import { themeDef } from "./themes";

export function ThemeCard({ id, on, onPick, onPreview, menu, onMenu, big }: { id: string; on: boolean; onPick: () => void; onPreview?: (id: string | null) => void; menu?: React.ReactNode; onMenu?: (e: React.MouseEvent) => void; big?: boolean }) {
  const def = themeDef(id);
  const thumb = useMemo(() => (def ? themeThumb(def, big ? 240 : 168, big ? 136 : 96) : ""), [def, big]);
  // a pointer passing over on its way somewhere should not flash the board
  const intent = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => () => clearTimeout(intent.current ?? undefined), []);
  if (!def) return null;
  const glass = `rgba(${def.tile.join(",")}, ${Math.min(0.95, def.tileAlpha + 0.08)})`;
  const by = def.custom?.by && def.custom.by !== "Context Board" ? def.custom.by : null;
  return (
    <div
      className={cx("theme-card", on && "is-on", big && "is-big")}
      onPointerEnter={() => {
        clearTimeout(intent.current ?? undefined);
        intent.current = setTimeout(() => onPreview?.(id), 110);
      }}
      onPointerLeave={() => clearTimeout(intent.current ?? undefined)}
      onContextMenu={
        onMenu
          ? (e) => {
              e.preventDefault();
              onMenu(e);
            }
          : undefined
      }
    >
      <button className="theme-card-pick" onClick={onPick} onFocus={() => onPreview?.(id)} aria-pressed={on} aria-label={`${def.name}${by ? `, by ${by}` : ""}`}>
        <span className={cx("theme-swatch", def.pixel && "is-pixel")} style={{ backgroundImage: `url(${thumb})` }}>
          <i style={{ background: glass, borderColor: def.border }}>
            <b style={{ background: def.accent }} />
          </i>
          <i style={{ background: glass, borderColor: def.border }} />
        </span>
        <span className="theme-name">{def.name}</span>
        {by && <span className="theme-by">by {by}</span>}
      </button>
      {menu}
    </div>
  );
}
